import { ARROW_SIZE } from '@keen.io/ui-core';
import { calculateHypotenuseHeight } from '@keen.io/charts-utils';
export var calculateTooltipPosition = function (_a) {
    var svgDimensions = _a.svgDimensions, margins = _a.margins, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    var xMaxPosition = svgDimensions.width - margins.right;
    var yMaxPosition = svgDimensions.height - margins.top;
    var hasXOverflow = x + width >= xMaxPosition;
    var hasYMaxOverflow = y + height / 2 >= yMaxPosition;
    var hasYMinOverflow = y - height / 2 <= 0;
    var arrowHeight = calculateHypotenuseHeight(ARROW_SIZE, ARROW_SIZE);
    var transform = 'translateY(-50%) translateX(20px)';
    var arrowDirection = 'left';
    var tooltipX = x;
    var tooltipY = y;
    var arrowTop;
    if (hasXOverflow) {
        transform = 'translateY(-50%) translateX(-20px)';
        arrowDirection = 'right';
        tooltipX = x - width;
    }
    if (hasYMinOverflow) {
        tooltipY = height / 2;
        arrowTop = y < arrowHeight ? arrowHeight : y;
    }
    if (hasYMaxOverflow) {
        tooltipY = yMaxPosition - height / 2;
        var arrowPosition = height - (yMaxPosition - y);
        arrowTop =
            yMaxPosition - arrowPosition > arrowHeight
                ? arrowPosition - arrowHeight
                : arrowPosition;
    }
    return {
        transform: transform,
        arrowDirection: arrowDirection,
        tooltipX: tooltipX,
        tooltipY: tooltipY,
        arrowTop: arrowTop,
    };
};
